import { BuildRCAttribute } from "@/commons/RCAttribute.ts";
import { DataTable, ETheme, IOption, Tooltip } from "@/DependenciesV9";
import { SelectionMode } from "@/DependenciesV9/DataTable/Enums/TableEnum.ts";
import { ETypeColumn } from "@/DependenciesV9/DataTable/Filter/Model";
import { IColumnDl } from "@/DependenciesV9/DataTable/Model.ts";
import { RootState } from "@/redux";
import { SearchResponse } from "@/services/entities/AxiosMethod.ts";
import { Roles } from "@/services/enums/SettingEnum.ts";
import { MapTypeDatabase } from "@/services/tenant-service/entities/Enums";
import { TenantInfo } from "@/services/tenant-service/entities/TenantEntity.ts";
import { ITenantListProps } from "@/views/tenants/Model.ts";
import { TenantListWrapper, TenantTableWrapper } from "@/views/tenants/Style.ts";
import { cloneDeep } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TenantList = (props: ITenantListProps) => {
  const {t} = useTranslation();
  const [tenantList, setTenantList] = useState<TenantInfo[]>([]);
  //const refDataTable = useRef<IRefDataTable | null>(null);
  const theme: ETheme = useSelector(
    (state: RootState) => state.settingInfo?.theme
  );

  const loadDataTable = async (
    filter?: string,
    isLazyLoading?: boolean
  ): Promise<SearchResponse<any>> => {
    console.log("filter", filter)
    if(props.onFetchTenantList) {
      const response = await props.onFetchTenantList(filter ? `${filter}&$count=true` : "");
      if(isLazyLoading) {
        const tenantListClone = cloneDeep(tenantList);
        setTenantList(tenantListClone.concat(response.data))
      } else {
        setTenantList(response.data)
      }
      return response
    }
    return new SearchResponse();
  };

  const databaseOptions: IOption[] = Object.keys(MapTypeDatabase).flatMap((x: string) => {
    const opt = {
      value: x,
      text: MapTypeDatabase[x],
    };
    return opt;
  });


  const tenantColumnLanscape: IColumnDl[] = [
    {
      key: "name",
      name: "Name",
      minWidth: 200,
      maxWidth: 400,
      data: ETypeColumn.STRING,
      onRender: (item: TenantInfo) => {
        const actionIdRc = BuildRCAttribute(`sp.${item.name}`);
        return (
          <Tooltip content={item.name} relationship={"label"}>
              <span {...actionIdRc}>
                {item.name}
              </span>
          </Tooltip>
        );
      },
    },
    {
      key: "ownerInfo",
      name: "Owner",
      minWidth: 200,
      maxWidth: 400,
      data: ETypeColumn.STRING,
      queryMultipleKeys: ["tenantInfo/owner/name", "tenantInfo/owner/email"],
      queryKey: "tenantInfo/owner/name",
      onRender: (item: TenantInfo) => {
        return `${item.owner?.name} (${item.owner?.email})`
      },
    },
    {
      key: "databaseConfigOption",
      name: "Database Type",
      minWidth: 100,
      maxWidth: 400,
      data: ETypeColumn.BOOLEAN_STRING,
      booleanFormOpts: databaseOptions,
      queryKey: "tenantInfo/databaseConfigOption",
      isEnum: true,
      onRender: (item: TenantInfo) => {
        return (
          t(item.databaseConfigOption)
        );
      },
    },
    // {
    //   key: "licenceType",
    //   name: "License Type",
    //   minWidth: 100,
    //   maxWidth: 400,
    //   data: ETypeColumn.BOOLEAN_STRING,
    //   queryKey: "tenantInfo/licenceInfo/licenceType",
    //   isEnum: true,
    //   //booleanFormOpts: LicenseTypeOpts,
    //   onRender: (item: TenantInfo) => {
    //     return t(item?.licenceInfo?.licenceType);
    //   },
    // },
    {
      key: "expireTime",
      name: "License Expiration",
      minWidth: 100,
      maxWidth: 400,
      data: ETypeColumn.DATE,
      queryKey: "tenantInfo/licenceInfo/expiredTime",
      onRender: (item: TenantInfo) => {
        return item?.licenceInfo?.expiredTime;
      },
    },
    {
      key: "status",
      name: "Status",
      minWidth: 100,
      maxWidth: 200,
      data: ETypeColumn.BOOLEAN_STRING,
      isEnum: true,
      //booleanFormOpts: StatusOpts,
      onRender: (item: TenantInfo) => {
        return t(item.status);
      },
    },
    // {
    //   key: "action",
    //   name: "Action",
    //   fieldName: "action",
    //   minWidth: 30,
    //   maxWidth: 60,
    //   priority: 1,
    //   data: "string",
    //   isNotFilter: true,
    //   isNotSort: true,
    //   onRender: (item: TenantInfo) => {
    //     if(this.tId !== item.guid && !this.props.role?.includes(Roles.ReadWriteAll)) return <></>;
    //     return (
    //       <Tooltip content="Edit" darkMode={this.props.theme}>
    //         <div
    //           className="custom-btn-action"
    //           {...this.renderRcId(`action.edit.tenant.${item.name}`)}
    //         >
    //           <Icon
    //             className="icon-custom-action"
    //             onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
    //               this._onOpenPanel(e, item)
    //             }
    //             iconName={"Edit"}
    //             rcName={`action.edit.tenant.${item.name}`}
    //           />
    //         </div>
    //       </Tooltip>
    //     );
    //   },
    // },
  ];
  return (
    <TenantListWrapper className="TenantListWrapper">
      {/* <TenantActionWrapper className="TenantActionWrapper">
        <Button onClick={onOpenFilter}>Filter</Button>
      </TenantActionWrapper> */}
      <TenantTableWrapper className="TenantTableWrapper">
        <DataTable
          rcName={`tenant.list`}
          columns={tenantColumnLanscape}
          //loading={this.props?.isLoadingQuery}
          theme={theme}
          //onChangeSelectedItems={this._onHandUpdateState}
          //iconName={`Org`}
          //selectedItems={this.state.selectedItems}
          requireRoles={[
            Roles.ReadWrite,
            Roles.ResourceReadWrite,
          ]}
          data={tenantList}
          isLazyLoad={true}
          isMobile={true}
          selectionMode={SelectionMode.Single}
          loadDataTable={loadDataTable}
        />
      </TenantTableWrapper>
    </TenantListWrapper>
  );
};

export default TenantList;